import { createContext, useContext } from "react";

import type { FarmSettingsTo } from "../../../generated/api/agroevidence";

type FarmSettingsContextValue = FarmSettingsTo | undefined;

const FarmSettingsContext = createContext<FarmSettingsContextValue>(undefined);

type FarmSettingsProviderProps = {
  settings: FarmSettingsTo | undefined;
  children: React.ReactNode;
};

const FarmSettingsProvider = ({
  children,
  settings,
}: FarmSettingsProviderProps): React.ReactElement => (
  <FarmSettingsContext.Provider value={settings}>
    {children}
  </FarmSettingsContext.Provider>
);

const useFarmSettingsContext = (): FarmSettingsContextValue =>
  useContext(FarmSettingsContext);

export { FarmSettingsProvider, useFarmSettingsContext };
